/**
 * The address of the management API. Set REACT_APP_API_BASE_URL in .env.development.local
 * to talk to your own API locally (the "PossibilIT.Connector.Management.Web.API" profile
 * listens on http://localhost:5000).
 *
 * Kept in one place so every caller, the axios client and the SignalR hubs alike, is
 * guaranteed to point at the same environment; a dashboard that pulls its list from one
 * environment and its detail from another is worse than no dashboard at all.
 */
export const apiBaseUrl =
    process.env.REACT_APP_API_BASE_URL ||
    'https://pitopsconnector.azurewebsites.net';

/** Path of the hub broadcasting the live queue state. Must match QueueMonitorHub.Path. */
export const queueHubUrl = `${apiBaseUrl.replace(/\/+$/, '')}/hubs/queues`;

/** Path of the hub streaming one object trace while it runs. Must match TraceHub.Path. */
export const traceHubUrl = `${apiBaseUrl.replace(/\/+$/, '')}/hubs/trace`;
